import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import cloud from "../assets/svgs/cloud.svg";

const DropZone = ({ files, onUpload }) => {
  const onDrop = useCallback(
    (acceptedFiles) => {
      onUpload([...files, ...acceptedFiles]);
    },
    [files, onUpload]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: ".pdf,.doc,.docx,.png,.jpg,.jpeg",
    maxSize: 10485760, // 10MB
  });

  return (
    <div>
      <div
        {...getRootProps()}
        className="border-2 border-dashed border-gray-300 rounded-lg p-4 py-8 cursor-pointer text-sm text-gray-500 text-center"
      >
        <input {...getInputProps()} />
        <div>
          <img src={cloud} className="w-12 h-12 mx-auto"/>
        </div>
        <p>Drop files to upload or <span className="text-blue">browse</span></p>
      </div>
      <ul className="mt-4">
        {files.map((file, index) => (
          <li key={index} className="flex justify-between items-center mb-2">
            <span className="text-sm text-gray-700">{file.name}</span>
            <button
              onClick={() => {
                const updatedFiles = files.filter((_, i) => i !== index);
                onUpload(updatedFiles);
              }}
              className="text-red-500 text-sm font-medium"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DropZone;
